// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBj2KaZGFxX4hvhV1_0B1oeh6n0v9rk1hc",
  authDomain: "heroic-game-day.firebaseapp.com",
  projectId: "heroic-game-day",
  storageBucket: "heroic-game-day.appspot.com",
  messagingSenderId: "39399506248",
  appId: "1:39399506248:web:bce93e3a5e2b3d5139b37d",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(app);
